<template>
  <div class="container">
    <el-row style="margin-bottom: 10px">
      <el-col :span="12" style="color: #028D66">
        <span style="margin-right: 20px">
          项目ID:{{ project_id }}
        </span>
        <span>
          项目名称：{{ project_name }}
        </span>
      </el-col>
    </el-row>

    <!--搜索-->
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--操作-->
    <section class="btn-group">
      <el-button v-if="this.is_admin" type="primary" round plain size="small" @click="handleAdd">新增出租屋</el-button>
      <el-upload v-if="this.is_admin" class="upload-demo btn" name="excel_file" :on-success="uploadSuccess"
        :on-error="uploadError" :show-file-list="false" action="https://dq-back.wzfire.com/import_site_czw"
        :headers="headers" :multiple="false"
        accept=".csv,.xlsx,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        <el-button type="primary" plain size="small" round style="margin-left: 10px;margin-right: 10px">导入出租屋
        </el-button>
      </el-upload>
      <el-button v-if="this.is_admin" type="primary" round plain size="small" @click="handleExport">下载告知书</el-button>
      <el-button v-if="this.is_admin" type="primary" round plain size="small" @click="handleBackJcz">退回检测中</el-button>
      <el-button type="primary" round plain size="small" @click="handleSubmitCheck">提交审核</el-button>
      <el-button type="primary" round plain size="small" @click="handleSubmitApprove">提交审批</el-button>
      <!-- <el-button type="primary" round plain size="small" @click="handleDownCjReport">下载初检报告</el-button> -->
      <el-button type="primary" round plain size="small" @click="handleDownFjReport">下载复检报告</el-button>
      <el-button type="primary" round plain size="small" @click="handleDownLedger">导出台账</el-button>
      <el-button type="primary" round plain size="small" @click="handleGenerateQr">生成并下载二维码</el-button>

      <!-- <el-button type="primary" round plain size="small" @click="handleDownCjAndFjReport">下载初检和复检报告</el-button> -->
    </section>

    <!--列表-->
    <el-table :data="tableData" @sort-change="handleSortChange" style="width: 100%;border-radius: 10px;" stripe border
      ref="multipleTable" @row-dblclick="handleDBClick" @selection-change="handleSelectionChange">
      <el-table-column type="selection" border label="序号" prop="id"></el-table-column>
      <el-table-column border min-width="70" label="场所ID" prop="site_id" fixed="left"></el-table-column>
      <el-table-column border min-width="180" label="报告编号" prop="report_code" show-overflow-tooltip
        fixed="left"></el-table-column>
      <el-table-column border min-width="200" label="项目地址" prop="site_address" show-overflow-tooltip
        fixed="left"></el-table-column>
      <el-table-column border min-width="50" label="户数" prop="hs" show-overflow-tooltip></el-table-column>
      <el-table-column border min-width="150" label="检测房间" prop="locations" show-overflow-tooltip></el-table-column>
      <el-table-column border min-width="130" label="入户率（%）" prop="rhl" show-overflow-tooltip sortable="custom"
        :formatter="formatRhl"></el-table-column>
      <el-table-column border min-width="100" label="直观流程" prop="zg_status" show-overflow-tooltip></el-table-column>
      <el-table-column border min-width="100" label="CMA流程" prop="cma_status" show-overflow-tooltip></el-table-column>
      <el-table-column border min-width="100" label="二维码" prop="qr_url">
        <template v-slot="scope">
          <img v-if="scope.row.qr_url" :src="scope.row.qr_url" alt="二维码"
            style="width:48px;height:48px;object-fit:contain;" />
        </template>
      </el-table-column>
      <el-table-column border min-width="100" label="整改率" prop="rectification_rate" show-overflow-tooltip>
        <template v-slot="scope">
          <el-link type="primary" @click="showRectificationDetails(scope.row)" :underline="false">
            {{ scope.row.rectification_rate }}%
          </el-link>
        </template>
      </el-table-column>
      <el-table-column border min-width="100" label="复检记录" align="center">
        <template v-slot="scope">
          <el-link v-if="scope.row.is_fj" type="primary" :underline="false"
            @click="handleRecheck(scope.row)">复检记录</el-link>
        </template>
      </el-table-column>
      <el-table-column border label="联系人" prop="client_leader" show-overflow-tooltip></el-table-column>
      <el-table-column border min-width="120" label="联系电话" prop="phone" show-overflow-tooltip></el-table-column>
      <el-table-column border label="建筑面积" prop="builder_area" show-overflow-tooltip></el-table-column>
      <el-table-column border label="受检面积" prop="detect_area" show-overflow-tooltip></el-table-column>
      <el-table-column border label="建筑层数" prop="builder_floor" show-overflow-tooltip></el-table-column>
      <el-table-column border label="使用性质" prop="builder_nature" show-overflow-tooltip></el-table-column>
      <el-table-column border label="房屋编码" prop="fwbm" show-overflow-tooltip></el-table-column>
      <el-table-column border label="网格员" prop="wgy" show-overflow-tooltip></el-table-column>
      <el-table-column border label="网格员联系方式" min-width="150" prop="wgy_phone" show-overflow-tooltip></el-table-column>
      <el-table-column border label="备注" prop="remark" show-overflow-tooltip></el-table-column>
      <el-table-column border label="操作" min-width="400" fixed="right">
        <template v-slot="scope">
          <div class="operation-buttons">
            <el-button size="mini" type="primary" plain
              @click="handleCommandRecord({ key: 'recordCma', row: scope.row })">
              原始记录CMA
            </el-button>
            <el-button size="mini" type="success" plain
              @click="handleCommandRecord({ key: 'downZgReport', row: scope.row })">
              下载直观报告
            </el-button>
            <el-button size="mini" type="success" plain
              @click="handleCommandRecord({ key: 'downCmaReport', row: scope.row })">
              下载CMA报告
            </el-button>
            <el-dropdown @command="handleCommandRecord" size="small" trigger="click">
              <el-button type="primary" size="mini" plain>其他操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu v-slot="dropdown">
                <!-- <el-dropdown-item :command="{ key: 'recordZg', row: scope.row }">原始记录直观版</el-dropdown-item> -->
                <!-- <el-dropdown-item :command="{ key: 'recordCma', row: scope.row }">原始记录CMA版</el-dropdown-item> -->
                <el-dropdown-item :command="{ key: 'recordDoc', row: scope.row }">原始记录档案</el-dropdown-item>
                <el-dropdown-item :command="{ key: 'reportZg', row: scope.row }" divided>在线直观报告</el-dropdown-item>
                <el-dropdown-item :command="{ key: 'reportCma', row: scope.row }">在线CMA报告</el-dropdown-item>
                <!-- <el-dropdown-item :command="{ key: 'downZgReport', row: scope.row }" divided>下载直观报告</el-dropdown-item> -->
                <!-- <el-dropdown-item :command="{ key: 'downCmaReport', row: scope.row }">下载CMA报告</el-dropdown-item> -->
                <el-dropdown-item :command="{ key: 'downNotice', row: scope.row }" divided>下载告知书(无图)</el-dropdown-item>
                <el-dropdown-item :command="{ key: 'downNoticePic', row: scope.row }">下载告知书(有图)</el-dropdown-item>
                <!-- <el-dropdown-item :command="{ key: 'employee', row: scope.row }" divided>设置人员</el-dropdown-item> -->
                <el-dropdown-item :command="{ key: 'site_log', row: scope.row }" divided>场所日志</el-dropdown-item>
                <el-dropdown-item v-if="is_admin" :command="{ key: 'del', row: scope.row }" divided>删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!--对话框-->
    <el-dialog title="新增出租屋" @close="initModel(addModel)" :visible.sync="addModel.addShow" width="800px">
      <el-form ref="addForm" :model="addModel" label-width="120px" :hide-required-asterisk="false" size="small">
        <el-form-item label="项目ID">
          <el-input v-model="addModel.project_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="报告编号">
          <el-input v-model="addModel.report_code" placeholder="新增之后不可修改"></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="addModel.project_name"></el-input>
        </el-form-item>
        <el-form-item label="项目地址">
          <el-input v-model="addModel.site_address"></el-input>
        </el-form-item>
        <el-form-item label="委托单位">
          <el-input v-model="addModel.client_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="addModel.client_leader"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="addModel.phone"></el-input>
        </el-form-item>
        <el-form-item label="建筑面积">
          <el-input v-model="addModel.builder_area"></el-input>
        </el-form-item>
        <el-form-item label="受检面积">
          <el-input v-model="addModel.detect_area"></el-input>
        </el-form-item>
        <el-form-item label="建筑楼层">
          <el-input v-model="addModel.builder_floor"></el-input>
        </el-form-item>
        <el-form-item label="建筑高度">
          <el-input v-model="addModel.builder_high"></el-input>
        </el-form-item>
        <el-form-item label="使用性质">
          <el-input v-model="addModel.builder_nature"></el-input>
        </el-form-item>
        <el-form-item label="网格员">
          <el-input v-model="addModel.wgy"></el-input>
        </el-form-item>
        <el-form-item label="网格员联系方式">
          <el-input v-model="addModel.wgy_phone"></el-input>
        </el-form-item>
        <el-form-item label="户数">
          <el-input v-model="addModel.hs"></el-input>
        </el-form-item>
        <el-form-item label="房屋编码">
          <el-input v-model="addModel.fwbm"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addModel.remark"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="编辑出租屋" @close="initModel(editModel)" :visible.sync="editModel.editShow" width="800px">
      <el-form ref="editForm" :model="editModel" label-width="120px" size="small">
        <el-form-item label="场所ID">
          <el-input v-model="editModel.site_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目ID">
          <el-input v-model="editModel.project_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="报告编号">
          <el-input v-model="editModel.report_code" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目地址">
          <el-input v-model="editModel.site_address"></el-input>
        </el-form-item>
        <el-form-item label="委托单位">
          <el-input v-model="editModel.client_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="editModel.client_leader"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="editModel.phone"></el-input>
        </el-form-item>
        <el-form-item label="建筑面积">
          <el-input v-model="editModel.builder_area"></el-input>
        </el-form-item>
        <el-form-item label="受检面积">
          <el-input v-model="editModel.detect_area"></el-input>
        </el-form-item>
        <el-form-item label="建筑楼层">
          <el-input v-model="editModel.builder_floor"></el-input>
        </el-form-item>
        <el-form-item label="建筑高度">
          <el-input v-model="editModel.builder_high"></el-input>
        </el-form-item>
        <el-form-item label="使用性质">
          <el-input v-model="editModel.builder_nature"></el-input>
        </el-form-item>
        <el-form-item label="网格员">
          <el-input v-model="editModel.wgy"></el-input>
        </el-form-item>
        <el-form-item label="网格员联系方式">
          <el-input v-model="editModel.wgy_phone"></el-input>
        </el-form-item>
        <el-form-item label="户数">
          <el-input v-model="editModel.hs"></el-input>
        </el-form-item>
        <el-form-item label="房屋编码">
          <el-input v-model="editModel.fwbm"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editModel.remark"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:200px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">编辑</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="安排项目人员" :visible.sync="employeeModel.show" width="800px">
      <el-form :model="employeeModel">
        <el-form-item label="检测人员">
          <el-select v-model="employeeModel.jc_users" multiple filterable default-first-option placeholder="请选择检测人员"
            style="width: 100%">
            <el-option v-for="item in project_employee_options" :key="item.label" :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主检">
          <el-select v-model="employeeModel.zj" multiple filterable default-first-option placeholder="请选择主检"
            style="width: 100%">
            <el-option v-for="item in project_employee_options" :key="item.value" :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="记录员">
          <el-select v-model="employeeModel.jly" multiple filterable default-first-option placeholder="请选择记录员"
            style="width: 100%">
            <el-option v-for="item in project_employee_options" :key="item.value" :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核人员">
          <el-select v-model="employeeModel.sh" filterable default-first-option placeholder="请选择审核人"
            style="width: 100%">
            <el-option v-for="item in project_employee_options" :key="item.value" :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批人员">
          <el-select v-model="employeeModel.sp" filterable default-first-option placeholder="请选择审批人"
            style="width: 100%">
            <el-option v-for="item in project_employee_options" :key="item.value" :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="onEmployee">提交并开始检测</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="按日期导出已完成场所告知书" :visible.sync="exportModel.show" width="500px">
      <el-alert title="该操作是按日期导出已完成场所的告知书，如果导出的场所数量过多，请缩短日期范围，要全部导出建议前往下载页导出" type="success"></el-alert>
      <br>
      <el-form :model="exportModel" label-width="80px">
        <el-form-item label="开始日期">
          <el-date-picker v-model="exportModel.start_date" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="exportModel.end_date" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 整改详情 -->
    <el-dialog title="整改详情" :visible.sync="rectificationDialogVisible" width="800px">
      <div v-if="currentRectificationDetails">
        <!-- 总体统计 -->
        <el-card class="rectification-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">总体整改情况</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">总问题数</div>
                <div class="stat-value">{{ currentRectificationDetails.total_count }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">已整改数</div>
                <div class="stat-value">{{ currentRectificationDetails.rectified_count }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-label">整改率</div>
                <div class="stat-value highlight">{{ currentRectificationDetails.overall_rate }}%</div>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 按级别统计 -->
        <el-card class="rectification-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">分级整改情况</span>
          </div>
          <el-table :data="levelData" border size="small">
            <el-table-column prop="level" label="问题级别" width="80" align="center">
              <template v-slot="scope">
                <el-tag :type="getLevelTagType(scope.row.level)" size="small">{{ scope.row.level }}级</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="total" label="总数" align="center"></el-table-column>
            <el-table-column prop="rectified" label="已整改" align="center"></el-table-column>
            <el-table-column prop="rate" label="整改率" align="center">
              <template v-slot="scope">
                <span :class="getRateClass(scope.row.rate)">{{ scope.row.rate }}%</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <!-- 检测类型分类统计 -->
        <el-card class="rectification-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">检测类型分类</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="type-stats">
                <h4>直观检测</h4>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <div class="mini-stat">
                      <div class="mini-label">总数</div>
                      <div class="mini-value">{{ currentRectificationDetails.zg_stats.total_count }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="mini-stat">
                      <div class="mini-label">已整改</div>
                      <div class="mini-value">{{ currentRectificationDetails.zg_stats.rectified_count }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="mini-stat">
                      <div class="mini-label">整改率</div>
                      <div class="mini-value">{{ currentRectificationDetails.zg_stats.overall_rate }}%</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="type-stats">
                <h4>CMA检测</h4>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <div class="mini-stat">
                      <div class="mini-label">总数</div>
                      <div class="mini-value">{{ currentRectificationDetails.cma_stats.total_count }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="mini-stat">
                      <div class="mini-label">已整改</div>
                      <div class="mini-value">{{ currentRectificationDetails.cma_stats.rectified_count }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="mini-stat">
                      <div class="mini-label">整改率</div>
                      <div class="mini-value">{{ currentRectificationDetails.cma_stats.overall_rate }}%</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headers: { Authorization: this.$Config.userinfo.token },
      sortField: '',  // 排序字段
      sortOrder: '',  // 排序方向：ascending/descending
      project_id: '',
      project_name: '',
      site_type: 'czw',
      drawer: false,
      loading: false,
      currentConfig: {},
      tableData: [],
      multipleSelection: [],
      is_admin: false,
      project_role: 0,
      query: { site_id: "", site_address: "", zg_status: "", cma_status: "" },
      pagination: { current_page: 1, total: 1, per_page: 10 },
      searchConfig: [
        { key: "site_id", label: "场所IDS", type: "input" },
        { key: 'site_address', label: "场所地址", type: "input" },
        {
          key: "zg_status", label: "直观流程", type: "select",
          list: [
            { text: "未开始", value: "未开始" },
            { text: "已完成", value: "已完成" },
            { text: "检测中", value: "检测中" },
            { text: "审核中", value: "审核中" },
            { text: "复检中", value: "复检中" },
            { text: "复检完成", value: "复检完成" },
            { text: "审批中", value: "审批中" },
            { text: "审批通过", value: "审批通过" },
            { text: "无检测", value: "无检测" }
          ],
        },
        {
          key: "cma_status",
          label: "CMA流程",
          type: "select",
          list: [
            { text: "未开始", value: "未开始" },
            { text: "已完成", value: "已完成" },
            { text: "检测中", value: "检测中" },
            { text: "审核中", value: "审核中" },
            { text: "复检中", value: "复检中" },
            { text: "复检完成", value: "复检完成" },
            { text: "审批中", value: "审批中" },
            { text: "审批通过", value: "审批通过" },
            { text: "无检测", value: "无检测" }
          ],
        },
      ],
      addModel: {
        addShow: false,
        project_id: '',
        report_code: '',
        project_name: '',
        site_address: '',
        client_name: '',
        client_leader: '',
        phone: '',
        builder_area: '',
        detect_area: '',
        builder_floor: '',
        builder_high: '',
        builder_nature: '',
        wgy: '',
        wgy_phone: '',
        hs: '',
        fwbm: '',
        remark: '',
      },
      editModel: {
        editShow: false,
        project_id: '',
        site_id: '',
        report_code: '',
        project_name: '',
        site_address: '',
        client_name: '',
        client_leader: '',
        phone: '',
        builder_area: '',
        detect_area: '',
        builder_floor: '',
        builder_high: '',
        builder_nature: '',
        wgy: '',
        wgy_phone: '',
        hs: '',
        fwbm: '',
        remark: '',
      },
      exportModel: {
        show: false,
        project_id: '',
        start_date: '',
        end_date: ''
      },
      project_employee_options: [],
      employeeModel: {
        project_id: '',
        site_id: '',
        show: false,
        jc_users: [],
        zj: [],
        jly: [],
        sh: '',
        sp: ''
      },
      allEmployeeModel: {
        project_id: '',
        show: false,
        jc_users: [],
        zj: [],
        jly: [],
        sh: '',
        sp: ''
      },
      // 整改详情对话框相关
      rectificationDialogVisible: false,
      currentRectificationDetails: null,
      levelData: []
    };
  },
  methods: {
    //生成二维码
    async handleGenerateQr() {
      console.log('开始生成二维码');
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请至少选择一行");
        return;
      }
      const siteIdValues = this.multipleSelection.map(row => row.site_id);
      const siteIds = siteIdValues.join(',');
      console.log('选中的场所ID:', siteIds);
      try {
        let res = await this.$Api.post('generate_wechat_qr', {
          project_id: this.project_id,
          site_ids: siteIds
        });
        console.log('API响应:', res);

        if (res.download_url) {
          // 创建隐藏的iframe来下载文件
          let elem = document.createElement("iframe");
          elem.src = res.download_url;
          elem.style.display = "none";
          document.body.appendChild(elem);
        }
        this.getList();

      } catch (e) {
        console.error('生成二维码异常:', e);
        this.$message.error(e.errormsg || "二维码生成失败");
      }
    },
    // 显示整改详情
    showRectificationDetails(row) {
      this.currentRectificationDetails = row.rectification_details;
      this.prepareLevelData();
      this.rectificationDialogVisible = true;
    },

    // 准备级别数据
    prepareLevelData() {
      if (this.currentRectificationDetails && this.currentRectificationDetails.level_rates) {
        this.levelData = Object.keys(this.currentRectificationDetails.level_rates).map(level => ({
          level: level,
          total: this.currentRectificationDetails.level_rates[level].total,
          rectified: this.currentRectificationDetails.level_rates[level].rectified,
          rate: this.currentRectificationDetails.level_rates[level].rate
        }));
      }
    },

    // 获取级别标签类型
    getLevelTagType(level) {
      const typeMap = {
        'A': 'danger',
        'B': 'warning',
        'C': 'info'
      };
      return typeMap[level] || 'info';
    },

    // 获取整改率样式类
    getRateClass(rate) {
      const rateNum = parseFloat(rate);
      if (rateNum >= 80) return 'rate-high';
      if (rateNum >= 50) return 'rate-medium';
      return 'rate-low';
    },

    // 保存当前搜索条件到 Vuex
    saveSearchState() {
      // 创建一个包含项目ID前缀的搜索配置
      const searchConfig = {
        projectId: this.project_id,
        siteType: 'czw',
        query: { ...this.query },
        pagination: { ...this.pagination },
        sortField: this.sortField,
        sortOrder: this.sortOrder
      };

      // 使用现有的 action 更新搜索配置
      this.$Store.dispatch('updateSearchConfig', searchConfig);
      // 同时更新 pageNumbers 状态
      this.$store.commit('SET_PAGE_NUMBER', {
        projectId: this.project_id,
        pageNumber: this.pagination.current_page
      });
    },

    handleSortChange({ column, prop, order }) {
      this.sortField = prop
      this.sortOrder = order
      this.getList()
      this.saveSearchState()
      this.saveSearchState()
    },
    formatRhl(row, column, cellValue) {
      if (!cellValue && cellValue !== 0) return '-'
      return Number(cellValue).toFixed(2)
    },
    //复检记录
    handleRecheck(row) {
      this.$router.push({ name: 'fj_record', params: { project_id: row.project_id, site_id: row.site_id } });
    },
    //提交审核
    async handleSubmitCheck() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请至少选择一行");
        return;
      }
      const siteIdVaules = this.multipleSelection.map(row => row.site_id)
      const siteIds = siteIdVaules.join(',')
      try {
        await this.$Api.post('submit_check', {
          project_id: this.project_id,
          site_ids: siteIds,
          site_type: this.site_type
        })
        this.getList()
        this.$message.success("提交成功")
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //提交审批中
    async handleSubmitApprove() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请至少选择一行");
        return;
      }
      const siteIdVaules = this.multipleSelection.map(row => row.site_id)
      const siteIds = siteIdVaules.join(',')
      try {
        await this.$Api.post('submit_approve', {
          project_id: this.project_id,
          site_ids: siteIds,
          site_type: this.site_type
        })
        this.getList()
        this.$message.success("提交成功")
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //下载初检报告
    async handleDownCjReport() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请至少选择一行");
        return;
      }
      const siteIdVaules = this.multipleSelection.map(row => row.site_id)
      const siteIds = siteIdVaules.join(',')
      try {
        let res = await this.$Api.post('down_cj_report', {
          project_id: this.project_id,
          site_ids: siteIds,
          site_type: this.site_type
        })
        window.open(res.url)
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //下载复检报告
    async handleDownFjReport() {
      if (this.multipleSelection.length !== 1) {
        this.$message.warning("请只选择一行（一个场所）");
        return;
      }
      const siteIdVaules = this.multipleSelection.map(row => row.site_id)
      const siteIds = siteIdVaules.join(',')
      try {
        let res = await this.$Api.post('down_fj_report', {
          project_id: this.project_id,
          site_ids: siteIds,
          site_type: this.site_type
        })
        window.open(res.url)
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //导出台账
    async handleDownLedger() {
      try {
        let res = await this.$Api.post('down_ledger', {
          project_id: this.project_id,
          site_type: this.site_type
        })
        windows.open(res.url)
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //下载初检和复检报告
    async handleDownCjAndFjReport() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请至少选择一行");
        return;
      }
      const siteIdVaules = this.multipleSelection.map(row => row.site_id)
      const siteIds = siteIdVaules.join(',')
      try {
        let res = await this.$Api.post('down_cj_and_fj_report', {
          project_id: this.project_id,
          site_ids: siteIds,
          site_type: this.site_type
        })
        window.open(res.url)
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //退回检测中
    async handleBackJcz() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请至少选择一行");
        return;
      }
      const siteIdVaules = this.multipleSelection.map(row => row.site_id)
      const siteIds = siteIdVaules.join(',')
      try {
        await this.$Api.post('back_jcz', {
          project_id: this.project_id,
          site_ids: siteIds,
          site_type: this.site_type
        })
        this.getList()
        this.$message.success("退回成功")
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //人员安排
    async handleEmployee(row) {
      try {
        let res = await this.$Api.post('get_site_employees', {
          project_id: row.project_id,
          site_id: row.site_id,
          site_type: 'other',
        })
        if (res) {
          this.employeeModel.jc_users = res.jc_users.split(',')
          this.employeeModel.zj = res.zj.split(',')
          this.employeeModel.jly = res.jly.split(',')
          this.employeeModel.sh = res.sh
          this.employeeModel.sp = res.sp
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
      this.employeeModel.show = true
      this.employeeModel.project_id = row.project_id
      this.employeeModel.site_id = row.site_id
    },
    async onEmployee() {
      try {
        await this.$Api.post('set_site_employees', {
          site_type: this.site_type,
          project_id: this.employeeModel.project_id,
          site_id: this.employeeModel.site_id,
          jc_users: this.employeeModel.jc_users.toString(),
          jly: this.employeeModel.jly.toString(),
          zj: this.employeeModel.zj.toString(),
          sh: this.employeeModel.sh,
          sp: this.employeeModel.sp,
        })
        this.employeeModel.show = false
        await this.getList()
        this.$message.success("设置成功")
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //按日期导出已完成场所的告知书
    handleExport() {
      this.exportModel.show = true
      this.exportModel.project_id = this.project_id
    },
    async onExport() {
      try {
        let res = await this.$Api.post('export_site_notices', {
          project_id: this.exportModel.project_id,
          site_type: this.site_type,
          start_date: this.exportModel.start_date,
          end_date: this.exportModel.end_date,
        })
        if (res) {
          let elem = document.createElement("iframe");
          elem.src = res.file_url;
          elem.style.display = "none";
          document.body.appendChild(elem);
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //获取人员下拉
    async getEmployeeOptions() {
      try {
        let res = await this.$Api.post('get_project_employee_options', { project_id: this.project_id })
        if (res) {
          this.project_employee_options = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //下载报告
    async handleDownReport(row, report_type) {
      try {
        let res = await this.$Api.post('down_report', {
          project_id: row.project_id,
          site_id: row.site_id,
          report_type: report_type,
          site_type: this.site_type
        })
        if (res) {
          let elem = document.createElement("iframe");
          elem.src = res.file_url;
          elem.style.display = "none";
          document.body.appendChild(elem);
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },

    handleDBClick(row) {
      this.editModel.editShow = true
      Object.keys(row).forEach(key => {
        if (this.editModel.hasOwnProperty(key)) {
          this.editModel[key] = row[key]
        }
      })
    },
    uploadSuccess() {
      this.getList()
      this.$message.success("上传成功");
    },
    uploadError(err) {
      this.$message.error(err);
    },
    //原始记录报告书操作
    handleCommandRecord(command) {
      let route_name = "";
      switch (command.key) {
        case 'recordZg':
          route_name = 'record_zg_index'
          break;
        case 'recordCma':
          route_name = 'record_cma_index'
          break;
        case 'reportZg':
          route_name = 'report_zg_fj1'
          break;
        case 'reportCma':
          route_name = 'report_cma_index'
          break;
        case 'recordDoc':
          route_name = 'site_doc'
          break;
        case 'downZgReport':
          this.handleDownReport(command.row, 'zg')
          break;
        case 'downCmaReport':
          this.handleDownReport(command.row, 'cma')
          break;
        case 'download':
          route_name = 'site_down'
          break;
        case 'downNotice':
          this.handleNotice(command.row)
          break;
        case 'downNoticePic':
          this.handleNoticePic(command.row)
          break;
        case 'employee':
          this.handleEmployee(command.row)
          break;
        case 'site_log':
          route_name = 'site_log'
          break;
        case 'del':
          this.handleDel(command.row)
          break;
      }
      // 保存当前页码
      this.$store.commit('SET_PAGE_NUMBER', { projectId: this.project_id, pageNumber: this.pagination.current_page });
      // 保存搜索条件
      this.saveSearchState();
      this.$router.push({
        name: route_name,
        params: {
          project_id: this.project_id,
          site_id: command.row.site_id,
          site_type: this.site_type,
          project_name: command.row.project_name
        }
      })
    },
    //告知书(无图)
    async handleNotice(row) {
      try {
        let res = await this.$Api.post('site_notice', { project_id: this.project_id, site_id: row.site_id })
        if (res) {
          let elem = document.createElement("iframe")
          elem.src = res.file_url
          elem.style.display = "none"
          document.body.appendChild(elem)
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //告知书（有图）
    async handleNoticePic(row) {
      try {
        let res = await this.$Api.post('site_notice_pic', { project_id: this.project_id, site_id: row.site_id })
        if (res) {
          let elem = document.createElement("iframe")
          elem.src = res.file_url
          elem.style.display = "none"
          document.body.appendChild(elem)
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //删除
    handleDel(row) {
      this.$confirm('确认删除?', '确认删除', {
        confirmButtonClass: '确认',
        cancelButtonClass: '取消',
        type: 'warning'
      }).then(
        async () => {
          try {
            let params = {
              id: row.id,
              project_id: this.project_id,
              site_id: row.site_id
            }
            await this.$Api.post('del_site_czw', params)
            this.$message.success('删除成功')
            await this.getList()
          } catch (e) {
            this.$message.error(e.errormsg)
          }
        }
      )
    },
    //初始化对话框
    initModel(model) {
      Object.keys(model).forEach(key => {
        if (key === 'addShow' || key === 'editShow' || key === 'show') {
          model[key] = false
        } else {
          model[key] = ''
        }
      })
    },
    //新增场所
    handleAdd() {
      this.addModel.addShow = true
      this.addModel.project_id = this.project_id
    },
    async onAdd() {
      try {
        let params = this.addModel
        params.project_id = this.project_id
        delete params.addShow
        await this.$Api.post('site_czw', params)
        this.$message.success('新增成功')
        this.initModel(this.addModel)
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.initModel(this.addModel)
    },
    //编辑场所
    handleEdit(row) {
      this.editModel.editShow = true
      Object.keys(row).forEach(key => {
        if (this.editModel.hasOwnProperty(key)) {
          this.editModel[key] = row[key]
        }
      })
    },
    async onEdit() {
      try {
        let params = this.editModel
        delete params.editShow
        delete params.project_name
        await this.$Api.post('edit_site_czw', params)
        this.$message.success('编辑成功')
        this.initModel(this.editModel)
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.initModel(this.editModel)
    },

    changePage() {
      this.getList();
      this.saveSearchState();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
      this.saveSearchState();
    },
    search() {
      this.pagination.current_page = 1;
      this.getList();
      this.saveSearchState();
    },
    reset() {
      this.query = {
        site_id: "",
        site_address: "",
        zg_status: "",
        cma_status: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
      this.saveSearchState();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
          project_id: this.$route.params.project_id,
          sort_field: this.sortField,      // 添加排序字段
          sort_order: this.sortOrder       // 添加排序方向
        };
        let data = await this.$Api.get("site_czw", { params: params });

        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data.map(item => ({
          ...item,
          is_fj: item.fj_start_time !== null && item.fj_start_time !== ''
        }));
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getProject() {
      try {
        let res = await this.$Api.post('get_project', { project_id: this.project_id })
        if (res) {
          this.project_name = res.project_name
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getProjectRole() {
      try {
        let res = await this.$Api.post('get_project_role', { project_id: this.project_id })
        if (res) {
          if (res.is_admin) {
            this.is_admin = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //保存当前搜索条件到Vuex

  },
  filters: {
    string_sub: function (str, len) {
      if (!str) return "";
      if (str.length > len) {
        return str.slice(0, len) + "...";
      }
      return str;
    },
    spiltByComma: function (str, index) {
      let arr = str.split(",")
      return arr[index]
    },
  },
  created() {
    this.project_role = this.$store.state.projectRole;
    this.project_id = this.$route.params.project_id;

    // 检查是否有保存的搜索条件
    const savedConfig = this.$Store.state.searchConfig;

    if (savedConfig &&
      savedConfig.projectId === this.project_id &&
      savedConfig.siteType === 'czw') {
      // 恢复搜索查询条件
      if (savedConfig.query) {
        this.query = { ...savedConfig.query };
      }

      // 恢复分页状态
      if (savedConfig.pagination) {
        // 页码已经通过 pageNumbers 恢复，这里恢复其他分页信息
        this.pagination.per_page = savedConfig.pagination.per_page || this.pagination.per_page;
        this.pagination.total = savedConfig.pagination.total || this.pagination.total;
      }

      // 恢复排序状态
      if (savedConfig.sortField) {
        this.sortField = savedConfig.sortField;
        this.sortOrder = savedConfig.sortOrder || '';
      }
    }

    // 恢复之前保存的页码（已有的代码）
    this.pagination.current_page = this.$store.state.pageNumbers[this.project_id] || 1;

    this.getProject()
    this.getEmployeeOptions()
    this.getList()
    this.getProjectRole()
  }
};
</script>
<style scoped>
.btn-group {
  display: flex;
  margin-bottom: 10px;
}

::v-deep .el-drawer__header {
  padding: 0px;
  margin: 0px;
}

.details-wrapper {
  position: relative;
}

.delete-button {
  position: absolute;
  margin-right: 10px;
  right: 0;
  top: 1;
}

.operation-buttons {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
}

.operation-buttons .el-button {
  padding-left: 8px;
  padding-right: 8px;
  margin: 0;
  white-space: nowrap;
}

/* Make the font size smaller for better fit */
.operation-buttons .el-button {
  font-size: 12px;
}

.rectification-card {
  margin-bottom: 20px;
}

.rectification-card:last-child {
  margin-bottom: 0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.stat-item {
  text-align: center;
  padding: 10px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
}

.stat-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 5px;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
}

.stat-value.highlight {
  color: #409EFF;
}

.type-stats {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 15px;
}

.type-stats h4 {
  margin: 0 0 15px 0;
  color: #303133;
  text-align: center;
}

.mini-stat {
  text-align: center;
  padding: 8px;
  background: #F5F7FA;
  border-radius: 4px;
  margin-bottom: 10px;
}

.mini-label {
  font-size: 11px;
  color: #909399;
  margin-bottom: 3px;
}

.mini-value {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
}

.rate-high {
  color: #67C23A;
  font-weight: bold;
}

.rate-medium {
  color: #E6A23C;
  font-weight: bold;
}

.rate-low {
  color: #F56C6C;
  font-weight: bold;
}
</style>
